<template>
  <div>
    <b-modal
      ref="modal-attlista"
      scrollable
      centered
      :hide-footer="true"
      @hide="hideModal"
      @close="hideModal"
    >
      <template #modal-title>
        Atualizar Lista Inteligente
      </template>

      <div>
        <label class="form-label">Deseja executar agora ou programar?</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="execute-now"
            value="now"
            v-model="executeOption"
          />
          <label class="form-check-label" for="execute-now">
            Executar agora
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="schedule"
            value="schedule"
            v-model="executeOption"
          />
          <label class="form-check-label" for="schedule">
            Programar
          </label>
        </div>
        <div v-if="currentRecurrence">
          <label class="form-label">Status</label>
          <ToogleSwitch v-model="status"/>
        </div>
      </div>

      <ModalPeriodicidade
        v-if="executeOption === 'schedule'"
        ref="ModalPeriodicidade"
        :trigger-generate="generateCronTrigger"
        @cron-generated="handleCronGenerated"
        :cron-expression="currentRecurrence ? currentRecurrence.cronPeriodicidade : null"
      />

      <DefaultButton
      btnVariant="btn-third justify-content-center"
      :disabled="!executeOption"
      :onClick="onCreateAcao"
      icon="fas fa-check-circle"
      text="Confirmar"
    />
    </b-modal>

    <AddConfirmation
      ref="AddConfirmationModal"
      warnText="Deseja atualizar a lista de contatos?"
      :saveFunction="finalizeCreateAcao"
    />
  </div>
</template>

<script>
import { toast, loading } from '@/shared/utils/UIHelper'
import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import RecorrenciaListaInteligenteRepository from '@/shared/http/repositories/configurations/recorrenciaListaInteligente.js'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import ModalPeriodicidade from '../component/ModalPeriodicidade.vue'
import DefaultButton from '@/components/UI/button/defaultButton.vue'

const AcaoListaInteligenteData = {
  acaoListaInteligente: 'ATT_LISTA_INTELIGENTE',
  cronExpression: null
}

export default {
  name: 'AttlistaInteligenteModal',
  data () {
    return {
      data: { ...AcaoListaInteligenteData },
      acaoListaId: null,
      executeOption: null,
      generateCronTrigger: false,
      status: false
    }
  },
  components: {
    AddConfirmation,
    ModalPeriodicidade,
    DefaultButton,
    ToogleSwitch
  },
  watch: {
    'acaoListaId': function (newId) {
      if (newId) {
        this.getRecorrencia()
      }
    }
  },
  methods: {
    openConfirmationModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.getRecorrencia()
        this.$refs['modal-attlista'].show()
      }
    },
    hideModal () {
      this.$refs['modal-attlista'].hide()
    },
    onCreateAcao () {
      if (this.executeOption === 'schedule') {
        this.generateCronTrigger = true
      } else {
        this.$refs['AddConfirmationModal'].showModal()
      }
    },
    handleCronGenerated (cronExpression) {
      this.data.cronExpression = cronExpression

      const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'ATT_LISTA_INTELIGENTE')

      if (foundRecurrence) {
        this.updateRecorrencia()
        this.$emit('reloadAcoes')
      } else {
        this.createRecorrencia()
        this.$emit('reloadAcoes')
      }
    },
    finalizeCreateAcao () {
      if (this.acaoListaId) {
        loading.push()
        ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
          .then((response) => {
            if (response.status === 201) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.hideModal()
              this.$emit('reloadAcoes')
            }
            loading.close()
          })
          .catch(this.onException)
      }
    },
    createRecorrencia () {
      const payload = {
        listaInteligenteId: this.acaoListaId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente
      }

      RecorrenciaListaInteligenteRepository.Create(payload)
        .then((response) => {
          if (response.status === 201) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
            this.getRecorrencia()
          }
        })
        .catch((error) => {
          console.error('Erro ao criar recorrência:', error)
        })
    },
    getRecorrencia () {
      RecorrenciaListaInteligenteRepository.GetById(this.acaoListaId)
        .then((response) => {
          if (response.status === 200 && Array.isArray(response.data.content)) {
            this.recorrencia = response.data.content

            const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'ATT_LISTA_INTELIGENTE')

            if (foundRecurrence) {
              this.currentRecurrence = foundRecurrence
              this.executeOption = 'schedule'
              this.data.cronExpression = foundRecurrence.cronPeriodicidade
              this.editCronExpression = this.data.cronExpression
              this.status = foundRecurrence.status
            } else {
              this.currentRecurrence = null
              this.executeOption = 'now'
              this.data.cronExpression = null
            }
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar recorrência:', error)
        })
    },
    updateRecorrencia () {
      if (!this.currentRecurrence) {
        return
      }

      const payload = {
        id: this.currentRecurrence.id,
        listaInteligenteId: this.acaoListaId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente,
        campanhaListaId: this.recorrencia[0].campanhaListaId,
        status: this.status
      }
      RecorrenciaListaInteligenteRepository.Update(this.currentRecurrence.id, payload)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.getRecorrencia()
          }
        })
        .catch((error) => {
          console.error('Erro ao atualizar recorrência:', error)
        })
    },
    toggleCreateUser () {
      this.status = !this.status
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/AttListaInteligenteModal.vue